import type { DepotFormValidation, DepotFormValues } from '../types'

import { validateLocation } from '@/utils'

import { useTexts } from './useTexts'

const validateForm =
  (texts: ReturnType<typeof useTexts>) =>
  (formValues: DepotFormValues): DepotFormValidation => {
    const { name, setupCost, setupTime, location } = formValues
    const { validation: validationTexts } = texts

    const validation: DepotFormValidation = {}

    if (!name) {
      validation.name = validationTexts.name
    }

    if (setupCost && isNaN(setupCost)) {
      validation.setupCost = validationTexts.setupCost
    }

    if (setupTime && isNaN(setupTime)) {
      validation.setupTime = validationTexts.setupTime
    }

    const locationValidationMessage = validateLocation(location)
    if (locationValidationMessage) {
      validation.location = locationValidationMessage
    }

    return validation
  }

export const useValidateForm = () => {
  const texts = useTexts()
  return validateForm(texts)
}
